module.exports = __webpack_public_path__ + "static/media/contact-info.32bd4840.png";